import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';

const useStyles = makeStyles(() => ({
  root: {
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 14,
  },
}));

function Title({ title, onClick }) {
  const classes = useStyles();
  return (
    <ButtonBase onClick={onClick} disableRipple>
      <Typography
        variant="body2"
        className={classes.root}
        color="textPrimary"
        align="left"
      >
        {title}
      </Typography>
    </ButtonBase>
  );
}

Title.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default Title;
